var map = {
	"./bug.svg": "2e38",
	"./dark.svg": "06b7",
	"./dragon.svg": "266d",
	"./electric.svg": "b66a",
	"./fairy.svg": "cb72",
	"./fighting.svg": "28d7",
	"./fire.svg": "7350",
	"./flying.svg": "b238",
	"./ghost.svg": "1e5e",
	"./grass.svg": "1384",
	"./ground.svg": "24d1",
	"./ice.svg": "c4b5",
	"./none.svg": "081a",
	"./normal.svg": "30e6",
	"./poison.svg": "7b5d",
	"./psychic.svg": "ddca",
	"./rock.svg": "ed41",
	"./steel.svg": "f148",
	"./water.svg": "0127"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bec2";